<div class="icon"></div>
<div class="content">
  <ng-content></ng-content>
</div>
